module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-bg1.png?573dab25";